/**
 * Danger callout for upload failures — replaces the bare red paragraph
 * under the dropzone so server rejections (size limits, machine fit,
 * unsupported type…) read as a designed state, not a stray error line.
 * Keeps the ``upload-error`` testid + ``role="alert"`` contract the
 * dropzone tests assert on.
 */
export function UploadErrorAlert({
  message,
  className,
  testId = "upload-error",
}: {
  message: string;
  className?: string;
  testId?: string;
}): JSX.Element {
  return (
    <div
      role="alert"
      data-testid={testId}
      className={`flex items-start gap-2.5 rounded-md border border-danger-border bg-danger-bg px-3.5 py-2.5 text-left ${className ?? ""}`}
    >
      <svg
        aria-hidden="true"
        className="mt-0.5 h-4 w-4 shrink-0 text-danger"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.75}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
        />
      </svg>
      <p className="text-sm font-medium text-danger">{message}</p>
    </div>
  );
}
